export var BreadcrumbStyles = function (props) {
    var theme = props.theme;
    if (!theme) {
        throw new Error('theme is undefined or null in base Breadcrumb getStyles function.');
    }
    var lastChildItem = {
        color: theme.palette.neutralPrimary,
        backgroundColor: 'transparent'
    };
    return {
        listItem: {
            selectors: {
                '&:last-child .ms-Breadcrumb-itemLink': lastChildItem,
                '&:last-child .ms-Breadcrumb-item': lastChildItem
            }
        }
    };
};
//# sourceMappingURL=Breadcrumb.styles.js.map